import React from 'react';
import { Grid, Paper, Box, Skeleton } from '@mui/material';

const LoadingSkeletons = () => (
  Array.from({ length: 3 }, (_, index) => (
    <Grid key={`skeleton-loading-${index}`} size={12}>
      <Paper sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Skeleton variant="rectangular" width={24} height={24} sx={{ mr: 2 }} />
          <Skeleton variant="text" width="40%" height={32} />
          <Box sx={{ flexGrow: 1 }} />
          <Skeleton variant="rectangular" width={80} height={24} sx={{ mr: 1 }} />
          <Skeleton variant="rectangular" width={100} height={24} />
        </Box>
        <Skeleton variant="rectangular" width="100%" height={8} sx={{ mb: 2, borderRadius: 1 }} />
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <Skeleton variant="rectangular" width="30%" height={40} />
          <Skeleton variant="rectangular" width="30%" height={40} />
          <Skeleton variant="rectangular" width="30%" height={40} />
        </Box>
        <Skeleton variant="rectangular" width="100%" height={120} sx={{ borderRadius: 1 }} />
      </Paper>
    </Grid>
  ))
);

export default LoadingSkeletons;